var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-list-page"},[_vm._l((_vm.gamesData),function(game){return _c('ItemCardList',{key:game.id,attrs:{"game":game}})}),(_vm.gamesData.length === 0)?_c('LoadingAnimation'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }